import { ReactElement } from "react";
import { ComponentEvent } from "@/graphHandling/graphTypes";
import { FormControlLabel, Radio } from "@mui/material";

export type RadioButtonState = {
  afterChanges: IRadioButtonProps;
  initial: IRadioButtonProps;
  current: IRadioButtonProps;
};

export interface IRadioButtonProps {
  id: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  label: string;
  name: string;
  styleClasses?: Array<string>;
  value: number | string;
}

interface IRadioButtonPropsWithEvents extends IRadioButtonProps {
  onChange: ComponentEvent;
}

/**
 * RadioButton-komponentin toteutus.
 * @param props
 * @returns
 */
export const RadioButton = (
  props: IRadioButtonPropsWithEvents
): null | ReactElement => {
  const handleChange = () => {
    props.onChange({
      changeProps: {
        id: props.id,
        value: props.value
      }
    });
  };

  return (
    <FormControlLabel
      value="start"
      className={props.styleClasses?.join(" ")}
      control={
        <Radio
          checked={props.isChecked}
          onChange={handleChange}
          value={props.value}
          name={props.name}
          inputProps={{ "aria-label": "A" }}
        />
      }
      label={props.label}
    />
  );
};
